module.exports = __webpack_public_path__ + "img/infobici.3e45f2a3.png";